import React from 'react';
import Scrutinize from '../components/Scrutinize/Scrutinize';
import CleanModernLayout from '../components/layouts/CleanModernLayout';

function ComprehensiveScan() {
  return (
    <CleanModernLayout>
      <Scrutinize />
    </CleanModernLayout>
  );
}

export default ComprehensiveScan;
